package com.dwarshb.bms

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.State
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import busmanagementsystem.composeapp.generated.resources.Res
import busmanagementsystem.composeapp.generated.resources.enter_phone_number
import busmanagementsystem.composeapp.generated.resources.enter_trip_code
import busmanagementsystem.composeapp.generated.resources.get_ticket
import busmanagementsystem.composeapp.generated.resources.get_ticket_description
import busmanagementsystem.composeapp.generated.resources.join_a_trip
import busmanagementsystem.composeapp.generated.resources.join_trip
import busmanagementsystem.composeapp.generated.resources.join_trip_desc
import com.mohamedrejeb.calf.ui.sheet.AdaptiveBottomSheet
import com.mohamedrejeb.calf.ui.sheet.rememberAdaptiveSheetState
import org.jetbrains.compose.resources.stringResource

@Composable
fun JoinTripScreen(viewModel: TripViewModel = TripViewModel(),
                   tripCode: String = "",
                   joinTrip:Boolean = true,
                   onGetTicketResult: (Trip,Booking)->Unit={_,_ ->},
                   onJoin: (Trip) -> Unit={},
                   onBackPressed: () -> Unit) {
    var code by remember { mutableStateOf(tripCode) }
    var number by remember { mutableStateOf("") }
    Column(modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState())) {

        AppIconTopBar {
            onBackPressed()
        }

        Card(
            modifier = Modifier.align(Alignment.CenterHorizontally)
                .padding(start =  24.dp, end = 24.dp, top = 24.dp),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.elevatedCardElevation(16.dp)
        ) {
            Column(modifier = Modifier.padding(16.dp)) {
                Text(
                    if(joinTrip) { stringResource(Res.string.join_a_trip)
                    } else { stringResource(Res.string.get_ticket) },
                    style = MaterialTheme.typography.headlineMedium,
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                )
                Text(
                    if (joinTrip) {stringResource(Res.string.join_trip_desc)}
                    else { stringResource(Res.string.get_ticket_description)},
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(bottom = 24.dp).align(Alignment.CenterHorizontally))
                OutlinedTextField(
                    modifier = Modifier.fillMaxWidth().padding(16.dp),
                    value = code,
                    onValueChange = { code = it },
                    label = { Text(stringResource(Res.string.enter_trip_code)) }
                )
                if(!joinTrip) {
                    OutlinedTextField(
                        modifier = Modifier.fillMaxWidth().padding(16.dp),
                        value = number,
                        onValueChange = { number = it },
                        label = { Text(stringResource(Res.string.enter_phone_number)) }
                    )
                }
                if(joinTrip) {
                    Button(
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFD81B60)),
                        modifier = Modifier.fillMaxWidth(), onClick = {
                            viewModel.getTrip(code) {
                                if (it != null) {
                                    onJoin(it)
                                }
                            }
//                        onJoin(code)
                        }) {
                        Text(stringResource(Res.string.join_trip))
                        Icon(Icons.AutoMirrored.Default.ArrowForward, contentDescription = "")
                    }
                }
                else {
                    Button(
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFD81B60)),
                        modifier = Modifier.fillMaxWidth(), onClick = {
                            viewModel.getTrip(code) { trip ->
                                if (trip != null) {
                                    viewModel.getYourTicket(code, number) {
                                        if (it != null) {
                                            onGetTicketResult(trip,it)
                                        }
                                    }
                                }
                            }
                        }) {
                        Text(stringResource(Res.string.get_ticket))
                        Icon(Icons.AutoMirrored.Default.ArrowForward, contentDescription = "")
                    }
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun ReserveSeat(
    trip: Trip,
    bookings: State<Map<String, Booking>>,
    requestTicket: (Booking)->Unit, onBackPressed: () -> Unit) {
    var showSeatLayout by remember { mutableStateOf(false) }
    val selectedSeatList = remember { mutableStateListOf<String>() }
    val passengerName = remember { mutableStateListOf<String>() }
    var reservedSeats = remember { mutableStateMapOf<String,String>() }

    LaunchedEffect(trip.selectedSeats) {
        selectedSeatList.clear()
        selectedSeatList.addAll(trip.selectedSeats)

        passengerName.clear()
        repeat(trip.selectedSeats.size) {
            passengerName.add("")
        }
    }
    var emailId by remember { mutableStateOf("") }
    var phoneNumber by remember { mutableStateOf("") }
    var phoneNumberError by remember { mutableStateOf(false) }
    Column(modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState())) {
        TopAppBar(
            title = {
                Row {
                    Text(trip.tripName, modifier = Modifier.weight(1f))
                }},
            navigationIcon = {
                IconButton(onClick = { onBackPressed() }) {
                    Icon(Icons.AutoMirrored.Default.ArrowBack, contentDescription = "")
                }
            },
        )
        Card(modifier = Modifier.padding(24.dp).align(Alignment.CenterHorizontally)
            .background(
                shape = RoundedCornerShape(18.dp),
                brush = Brush.verticalGradient(
                    listOf(
                        Color(0xFF6A11CB),
                        Color(0xFF2575FC)
                    )
                )
            ),
            colors = CardDefaults.cardColors(containerColor = Color.Transparent)) {
            Spacer(modifier = Modifier.height(16.dp))
            Text("Trip Summary",
                style = MaterialTheme.typography.headlineMedium,
                color = Color.White,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.align(Alignment.CenterHorizontally))
            Spacer(modifier = Modifier.height(24.dp))
            TripReviewLayout(trip,true)
            if (selectedSeatList.size>0) {
                Card(
                    modifier = Modifier.fillMaxWidth().padding(16.dp),
                    elevation = CardDefaults.cardElevation(8.dp)
                ) {
                    Column(modifier = Modifier.padding(16.dp)) {
                        Text(
                            "Seat Information", style = MaterialTheme.typography.titleLarge,
                            fontWeight = FontWeight.Bold
                        )
                        Spacer(modifier = Modifier.height(16.dp))
                        Text("Number of Seats ${selectedSeatList.size}")

                        // Ensure list has correct size before rendering fields
                        LaunchedEffect(selectedSeatList.size) {
                            if (passengerName.size < selectedSeatList.size) {
                                repeat(selectedSeatList.size - passengerName.size) {
                                    passengerName.add("")
                                }
                            }
                        }

                        if (selectedSeatList.size > 0 && passengerName.size == selectedSeatList.size) {
                            repeat(selectedSeatList.size) { seatIndex ->
                                OutlinedTextField(
                                    value = passengerName[seatIndex],
                                    onValueChange = { passengerName[seatIndex] = it },
                                    leadingIcon = {
                                        Text(
                                            selectedSeatList[seatIndex],
                                            color = Color.Black,
                                            fontWeight = FontWeight.Bold,
                                            modifier = Modifier
                                                .padding(8.dp)
                                                .border(1.dp, Color.Black)
                                                .padding(8.dp)
                                        )
                                    },
                                    label = { Text("Enter Passenger Name") }
                                )
                            }
                        }
                        HorizontalDivider(thickness = 0.5.dp, color = Color.Black,
                            modifier = Modifier.padding(16.dp))
                        Text("Seat Price : $${trip.costPerSeat}",
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.align(Alignment.End))
                        Text("Total Cost : $${(selectedSeatList.size*trip.costPerSeat.toInt())}",
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.align(Alignment.End))
                        Spacer(modifier = Modifier.height(24.dp))
                    }
                }

            }
            Button(colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFD81B60)),
                modifier = Modifier.align(Alignment.CenterHorizontally),
                onClick = { showSeatLayout = true }) {
                Text("Select Seat")
            }

            Card(modifier = Modifier.fillMaxWidth().padding(16.dp),
                elevation = CardDefaults.cardElevation(8.dp)) {
                Column(modifier = Modifier.padding(16.dp)) {
                    OutlinedTextField(
                        value = emailId,
                        onValueChange = {emailId = it},
                        label = { Text("Primary Email Id") },
                        supportingText = { Text("To receive Booking Information") }
                    )
                    OutlinedTextField(
                        value = phoneNumber,
                        isError = phoneNumberError,
                        onValueChange = {
                                            phoneNumberError = false
                                            phoneNumber = it
                                        },
                        label = { Text("Primary Phone Number") },
                        supportingText = { Text("For organizer to contact you") }
                    )
                    Spacer(modifier = Modifier.height(24.dp))
                    Button(modifier = Modifier.align(Alignment.CenterHorizontally),
                        onClick = {
                            if (phoneNumber.isEmpty()) {
                                phoneNumberError = true
                            } else {
                                val booking = Booking(
                                    trip.id,
                                    (selectedSeatList.size*trip.costPerSeat.toInt()).toString(),
                                    emailId,
                                    phoneNumber,
                                    selectedSeatList,
                                    passengerName
                                )
                                requestTicket(booking)
                            }
                        }){
                        Text("Request Booking")
                        Icon(Icons.Default.CheckCircle,"")
                    }
                }
            }
            Spacer(modifier = Modifier.height(24.dp))
        }

        bookings.value.forEach {
            reservedSeats.putAll(it.value.selectedSeats.zip(it.value.passengerDetails))
        }
        val seats = List(trip.totalSeats+1) { index ->
            val seatNumber = index.toString()
            val reservedBy =
                if (trip.coachType=="Sleeper"){
                    if (reservedSeats.containsKey("U $seatNumber")) {
                        reservedSeats["U $seatNumber"]
                    } else {
                        reservedSeats["L $seatNumber"]
                    }
                } else {
                    reservedSeats[seatNumber]
                }
            BusSeat(seatNumber, trip.coachType, isBooked = reservedBy!=null)

        }

        if (showSeatLayout) {
            BottomSheetSeatLayout(trip,seats,selectedSeatList) {
                showSeatLayout = false
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun BottomSheetSeatLayout(trip: Trip, seats: List<BusSeat>,selectedSeatList: MutableList<String>, onSeatsConfirm: ()-> Unit) {
    var selectedTab by remember { mutableStateOf(0) }
    var sheetState = rememberAdaptiveSheetState()

    AdaptiveBottomSheet(
        onDismissRequest = { onSeatsConfirm() },
        adaptiveSheetState = sheetState
    ) {
        Spacer(modifier = Modifier.height(16.dp))
        val titles = listOf("Upper Deck","Lower Deck")
        if (trip.coachType == "Sleeper") {
            TabRow(
                selectedTabIndex = selectedTab
            ) {
                titles. forEachIndexed { index, s ->
                    Tab(
                        selected = selectedTab==index,
                        onClick = { selectedTab = index},
                        text = { Text(s) }
                    )
                }
            }
        }

        SeatLayout(
            seats = seats,
            coachType = trip.coachType,
            deck = if (trip.coachType=="Sleeper") titles[selectedTab].first().toString() else "",
            selectedSeats = selectedSeatList,
            leftSeats = trip.busLayout?.leftRow?:2,
            rightSeats = trip.busLayout?.rightRow?:2,
            backSeats = trip.busLayout?.backRow?:2,
            hideAvailableSeatsText = true,
            hideConfirmButton = true,
            onSeatSelected = {
                if (selectedSeatList.contains(it)) {
                    selectedSeatList.remove(it)
                } else {
                    selectedSeatList.add(it)
                }
            }
        )
    }
}